











































































import { Component, PropSync, Vue } from 'vue-property-decorator';

import FlagshipProfilingSowosWealthViewModel
  from '@/vue-app/view-models/components/flagship/flagship-profiling/flagship-profiling-sowos-wealth-view-model';

@Component({
  name: 'FlagshipProfilingSowosWealth',
  components: {
    FlagshipProfilingExitPoll: () => import('@/vue-app/components/flagship/flagship-profiling/FlagshipProfilingExitPoll.vue'),
  },
})
export default class FlagshipProfilingSowosWealth extends Vue {
  @PropSync('isOpen', { type: Boolean, required: true })
  synced_is_open!: boolean;

  flagship_wealth_view_model = Vue.observable(
    new FlagshipProfilingSowosWealthViewModel(),
  );

  updateInformation() {
    this.$emit('hideRecommended');
    this.flagship_wealth_view_model.updateInformation();
  }

  showContractSavingsModal() {
    this.$emit('hideRecommended');
    this.$emit('contractWealth');
    this.synced_is_open = false;
  }

  closeModal() {
    this.$emit('hideRecommended');
    this.synced_is_open = false;
    this.flagship_wealth_view_model.showPollModal();
  }
}
